import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'

import { GRID_SERVICE_NAME, GridService } from '../../../services/grid'

import { IssueDirectiveController } from './issues-details.directive.controller'

import { IssueHelper } from '../issues.helper'
import { ATTACHMENT_SERVICE_NAME, AttachmentService } from '../../../services/attachments'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

//#region Asset Imports

import * as TEMPLATE from './issues-details.tpl.html'

//#endregion


// Setup

export class IssueDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, 'logger', 'localDictionary', USER_SESSION_SERVICE_NAME, GRID_SERVICE_NAME, ATTACHMENT_SERVICE_NAME, (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSession: UserSessionService,
        gridService: GridService,
        attachmentService: AttachmentService
    ) => new IssueDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        userSession,
        gridService,
        attachmentService,
        IssueHelper.REFERENCE_TYPE,
        IssueHelper.SIMAX_MODULE_NAME
    )]
    controllerAs = '$ctrl'
    template = TEMPLATE
}

// Setup End